export const AUTH = {
  LOGIN: 'v2/auth/login',
  REGISTER: 'v2/auth/register',
  LOGOUT: 'v2/auth/logout',
  VERIFY_EMAIL_OTP: 'v2/auth/email/verify',
  RESEND_EMAIL_OTP: 'v2/auth/email/resend',
  VERIFY_MOBILE_OTP: 'v2/auth/otp/verify',
  REQUEST_OTP_LOGIN: 'v2/auth/otp/request',
  FORGOT_PASSWORD: 'v2/auth/forgot-password',
  RESET_PASSWORD: 'v2/auth/reset-password',
};

export const USER = {
  PROFILE: '/user/profile',
  UPDATE: '/user/update',
  WINNERS: 'v2/users/winners/list',
};

export const REPORT = {
  BIDDERS: 'bidder-report',
  BIDDERS_EXPORT: 'v2/report/bidders',
  TRANSACTIONS_EXPORT: 'v2/report/transactions',
};

export const GROUP = {
  LIST: 'v2/groups/list',
};

export const AUCTION = {
  LIST: 'list/auctions',
  ACKNOWLEDGEMENT_VIEW: (auctionId) => `v2/auctions/${auctionId}/acknowledgement/view`,
};

export const CASH_FLOW = {
  DASHBOARD: 'v2/cash-flow-dashboard',
  ENROLLMENT: 'v2/cash-flow-dashboard/enrollment',
  AUCTION_PAYMENT: 'v2/cash-flow-dashboard/auction-payment',
  AUCTION_PAYMENT_DETAILS: 'v2/cash-flow-dashboard/auction-payment/details',
  CLIENT_PAYOUT_DETAILS: 'v2/cash-flow-dashboard/client-payout/details',
  RECHARGE: 'v2/cash-flow-dashboard/recharge',
  WITHDRAWAL: 'v2/cash-flow-dashboard/withdrawal',
  TRANSACTION: 'v2/cash-flow-dashboard/transactions',
};

export const CLIENT = {
  CLIENTS_LIST: 'v2/organizations/list',
};
